import { render } from "./tabJobs.vue?vue&type=template&id=721cad7f&scoped=true"
import script from "./tabJobs.vue?vue&type=script&lang=js"
export * from "./tabJobs.vue?vue&type=script&lang=js"

import "./tabJobs.vue?vue&type=style&index=0&id=721cad7f&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721cad7f"]])

export default __exports__